module.exports = {
  RETRIEVE_OUTBOUND_CARRIER_REQUEST: 'RETRIEVE_OUTBOUND_CARRIER_REQUEST',
  RETRIEVE_OUTBOUND_CARRIER_SUCCESS: 'RETRIEVE_OUTBOUND_CARRIER_SUCCESS',
  RETRIEVE_OUTBOUND_CARRIER_FAILURE: 'RETRIEVE_OUTBOUND_CARRIER_FAILURE',
  CARRIER_CHECKED: 'CARRIER_CHECKED',
  SELECT_ALL_CARRIERS: 'SELECT_ALL_CARRIERS',
  DESELECT_ALL_CARRIERS: 'DESELECT_ALL_CARRIERS',
};
